/**
 * Route for `no-code-rule-builder-with-natural-language-prompts`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { NoCodeRuleBuilderWithNaturalLanguagePromptsPage } from "../features/no-code-rule-builder-with-natural-language-prompts/NoCodeRuleBuilderWithNaturalLanguagePromptsPage";

export const noCodeRuleBuilderWithNaturalLanguagePromptsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/no-code-rule-builder-with-natural-language-prompts",
	component: NoCodeRuleBuilderWithNaturalLanguagePromptsPage,
});

export default noCodeRuleBuilderWithNaturalLanguagePromptsRoute;
